import { u as m, e as g, A as I, C as c } from "./main-bb89b2f2.js";
import { t as h } from "./toNumber-f405d8e0-e5c83f11.js";
var o = 1 / 0, y = 17976931348623157e292;
function a(r) {
  if (!r)
    return r === 0 ? r : 0;
  if (r = h(r), r === o || r === -o) {
    var i = r < 0 ? -1 : 1;
    return i * y;
  }
  return r === r ? r : 0;
}
function A(r, i, n) {
  if (!m(n))
    return !1;
  var e = typeof i;
  return (e == "number" ? g(n) && I(i, n.length) : e == "string" && i in n) ? c(n[i], r) : !1;
}
var M = Math.ceil, N = Math.max;
function C(r, i, n, e) {
  for (var t = -1, f = N(M((i - r) / (n || 1)), 0), u = Array(f); f--; )
    u[e ? f : ++t] = r, r += n;
  return u;
}
function R(r) {
  return function(i, n, e) {
    return e && typeof e != "number" && A(i, n, e) && (n = e = void 0), i = a(i), n === void 0 ? (n = i, i = 0) : n = a(n), e = e === void 0 ? i < n ? 1 : -1 : a(e), C(i, n, e, r);
  };
}
var x = R();
const T = x;
export {
  T as r
};
